import { ControllerDtoDaoOutputDto } from "~/api/apiRouteTypes/DaosRoute";
import { fetchData } from "~/utils/fetch";

type SuccessResult = {
  code: "000";
  data: ControllerDtoDaoOutputDto;
};

/** @description 권한이 없을 경우 */
type NoPermissionResult = {
  code: "001";
  data: null;
};

/** @description 존재하지 않을 경우 */
type NotFoundResult = {
  code: "100";
  data: null;
};

export type DaoOutput = ControllerDtoDaoOutputDto;

export type DaoResult = SuccessResult | NoPermissionResult | NotFoundResult;

type Props = { daoId: string };

/** @description DAO ID로 정보 조회 */
export const getDao = ({ daoId }: Props) =>
  fetchData<DaoResult>({
    url: `/daos/${daoId}`,
  });
